import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { selectActiveAccounts, selectSelectedAccount } from '@mkp/account/state';
import { Store } from '@ngrx/store';
import { filter, Observable, tap } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { concatLatestFrom } from '@ngrx/operators';
import { selectIsBoUser } from '@mkp/user/state-logged-in/selectors';
import { isNotNull } from '@mkp/shared/util-guards';
import { authWorkspaceGuardActions } from '@mkp/auth/actions';
import { selectWorkspaceFromUrlStatus } from '@mkp/auth/state';
import { WorkspaceFromUrlStatus } from '@mkp/auth/state';
import { getLoadedResult } from './helpers';

export function hasSelectedWorkspaceGuard(): Observable<true | UrlTree> {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(selectWorkspaceFromUrlStatus).pipe(
    filter((state) => state !== WorkspaceFromUrlStatus.INIT),
    take(1),
    concatLatestFrom(() => [
      store.select(selectIsBoUser).pipe(filter(isNotNull)),
      store.select(selectActiveAccounts).pipe(filter(isNotNull)),
    ]),
    concatLatestFrom(() => store.select(selectSelectedAccount)),
    tap(([, selectedAccount]) => !selectedAccount && clearWorkspaceResourceLoading(store)),
    map(([[, isBoUser], selectedAccount]) => getLoadedResult(router, !!selectedAccount, isBoUser))
  );
}

const clearWorkspaceResourceLoading = (store: Store) => {
  store.dispatch(authWorkspaceGuardActions.redirectedOnNoSelectedWorkspace());
};
